export default __webpack_public_path__ + "static/media/39_p._rain.dd17d2c3.png";